(ns frontend.view.settings2.web-form.view
  ;;  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require [common.features.plan :as plan]
            [common.localization :as loc]
            [common.sync-progress :as sync-progress]
            [common.util :as cu]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]
            [frontend.view.not-found :as not-found]
            [frontend.view.profile.view :as profile]
            [frontend.view.settings2.web-form.branding :as branding]
            [frontend.view.settings2.web-form.event :as event]
            [frontend.view.settings2.web-form.events :as events]
            [frontend.view.settings2.web-form.properties :as properties]
            [frontend.view.settings2.web-form.questions :as questions]
            [frontend.view.settings2.web-form.sub :as sub]
            [frontend.view.settings2.web-form.submitter-guidance :as submitter-guidance]
            [frontend.view.settings2.web-form.thank-you-page :as thank-you-page]
            [frontend.view.syncing-data :as sync]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.components.link.view :as link]
            [ui.components.radix-ui.dropdown-menu.view :as radix-dropdown]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.editors.labelled-input.view :as labelled-input]))

(defonce state (r/atom {}))
(defonce component-state (r/cursor state [:component-state]))
(defonce edit-state (r/cursor state [:edit-state]))

(defn webentry-listing
  [entity-atom selected-webentry webentries feature-on?]
  [:div
   {:class "flex flex-row justify-end pb-3 items-center gap-3"}
   [:span
    {:class "font-semibold"}
    "Webform"]
   [:div
    {:class "w-64 *:w-full"}
    [radix-dropdown/view
     {:trigger [:div
                {:class "w-full px-4 py-2 text-left inline-flex items-center justify-start gap-4 border text-input-light-text border border-solid border-input-light-border-paler rounded"}
                [:span
                 {:class "block w-11/12 truncate"}
                 (:webentry/display-name selected-webentry)]
                [:i.fal.fa-chevron-down]]
      :items   (concat [{:label        "+ Add new webentry form"
                         :custom-class "text-base-regular-text bg-base-regular px-2 py-2 cursor-pointer rounded"
                         :on-click     (fn [_]
                                         (events/create-webentry feature-on?))}]
                       (->> webentries
                            (mapv (fn [c]
                                    {:label        (:webentry/display-name c)
                                     :custom-class "py-2 px-2 text-base-light-text hover:bg-base-gloomy cursor-pointer rounded truncate"
                                     :on-click     (fn []
                                                     (rf/dispatch [::event/set-selected-webentry-id (:db/id c)]))}))))}]]
   [tooltip/view
    [:i
     {:class "fa fa-circle-info"}]
    (loc/tr :webform-archived-info)]
   [labelled-input/view
    {:label       (loc/tr :common/archived?)
     :value       (true? (:common/archived? selected-webentry))
     :editor-type :editor.type/toggle
     :horizontal? true
     :on-change   (fn [_]
                    (events/archive-webform! entity-atom selected-webentry))}]])

(defn summary-view
  [webentry]
  [:div
   {:class "p-4 lg:p-6 bg-base-regular text-base-regular-text rounded"}
   [:div
    {:class "flex flex-col gap-3"}
    [:span {:class "lg:text-xl"} "The Zapflow web form lets the target companies do the data entry for you."]
    [:span {:class "text-xs"} "Pro tip: include this link in your email signature"]]
   ;; [:div
   ;;  (loc/tr :personal-profile/web-form-info)]
   ;; [:label
   ;;  (loc/tr :web-form-settings/unique-url)]
   [profile/web-form-address (fu/cs "settings2-webentry-address") webentry true]])

(defn webentry-view
  [{:keys [webentry system-form? feature-on?]}]
  (let [entity-atom (r/cursor session/entities [(:db/id webentry)])]
    (fn [{:keys [system-form? feature-on?]}]
      (let [webentry @entity-atom
            webentries (->> @session/all-webentries
                            (remove :common/disabled?)
                            (sort-by :common/created-on))]
        (if (not= :webentry.type/custom (:webentry/type webentry))
          [:div
           [webentry-listing entity-atom webentry webentries feature-on?]
           [:div
            {:class " grid grid-cols-1 md:grid-cols-10 flex flex-row"}
            [:div
             {:class "max-w-full md:col-span-2 sticky mb-6 top-0 flex md:flex-col gap-3 md:gap-1 md:gap-4
                               text-base-light-text font-semibold *:truncate"}
             [link/side-nav-link {:active?  (= :summary (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :summary))}
              "Summary"]
             [link/side-nav-link {:active?  (= :submitter-guidance (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :submitter-guidance))}
              "Submitter guidance"]
             [link/side-nav-link {:active?  (= :questions (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :questions))}
              (loc/tr :web-form-settings/title-questions)]
             [link/side-nav-link {:active?  (= :thank-you-page (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :thank-you-page))}
              (loc/tr :web-form-settings/title-thank-you-page)]
             [link/side-nav-link {:active?  (= :properties (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :properties))}
              "General settings"]
             [link/side-nav-link {:active?  (= :branding (:selected-tab @component-state))
                                  :on-click (fn []
                                              (swap! component-state assoc :selected-tab :branding))}
              "Branding"]]
            [:div
             ^{:key (:db/id webentry)}
             {:class "md:col-span-8 flex flex-col"}

             (case (:selected-tab @component-state)
               :summary
               [:div
                [summary-view webentry]]
               :submitter-guidance
               [:div
                [submitter-guidance/view
                 {:webentry     webentry
                  :system-form? system-form?
                  :entity-atom  entity-atom
                  :state        state
                  :edit-state   edit-state}]]
               :questions
               [:div
                [questions/view
                 {:webentry     webentry
                  :system-form? system-form?
                  :entity-atom  entity-atom
                  :state        state
                  :edit-state   edit-state}]]
               :thank-you-page
               [:div
                [thank-you-page/view
                 {:webentry    webentry
                  :entity-atom entity-atom
                  :state       state}]]
               :properties
               [:div
                [properties/view
                 {:webentry     webentry
                  :system-form? system-form?
                  :entity-atom  entity-atom
                  :state        state
                  :edit-state   edit-state}]]
               :branding
               [:div
                [branding/view
                 {:webentry     webentry
                  :system-form? system-form?
                  :entity-atom  entity-atom
                  :state        state
                  :edit-state   edit-state}]]
               [:div
                [summary-view webentry]])]]]
          [:div
           [webentry-listing entity-atom webentry webentries feature-on?]
           [:div
            {:class "w-3/4 flex justify-center"}
            [properties/view
             {:webentry     webentry
              :system-form? system-form?
              :entity-atom  entity-atom
              :state        state
              :edit-state   edit-state}]]])))))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/webform-settings)]])

(defn component
  []
  (rf/dispatch [::event/set-first-webentry @session/all-webentries #{}])
  (swap! component-state assoc :selected-tab :summary)
  (r/create-class
   {:reagent-render
    (fn []
      (let [webentries (->> @session/all-webentries
                            (remove :common/disabled?)
                            (sort-by :common/created-on))
            system-form (first webentries)
            selected-webentry-id @(rf/subscribe [::sub/selected-webentry-id])
            selected-webentry (get @session/entities selected-webentry-id)
            webentry (->> webentries
                          (cu/filter-by :db/id selected-webentry-id)
                          (first))
            system-form? (= (:db/id webentry)
                            (:db/id system-form))
            feature-on? (plan/available :feature/multiple-web-forms @session/tenant @session/role)
            not-found? (or (nil? selected-webentry)
                           (:common/disabled? selected-webentry))]
        [:<>
         [zap-toolbar/view component-state
          breadcrumbs
          nil nil]
         [:div
          {:class "bg-base-light text-base-light-text"}
          [:div
           {:class "px-4 py-6 mx-auto xl:w-5xl"}
           [:div
            [:div
             [:div
              (if not-found?
                [:div
                 {:class "text-danger-light-text"}
                 (loc/tr :web-form-settings/not-found)
                 [:div
                  (loc/tr :web-form-settings/not-found-info)]]
                ^{:key (str ::web-entry "-" selected-webentry-id)}
                [webentry-view
                 {:webentry     webentry
                  :system-form? system-form?
                  :feature-on?  feature-on?}])]]]]]]))}))

(defmethod routing/render-view :new-settings-web-form
  [_]
  (if (session/is-admin?)
    [default-page-layout/view
     {:class-name ""}
     [sync/wait-until-sync-progress sync-progress/OPTIONS-TASKS
      [component]]]
    [not-found/not-found-view]))
